<template>
    <v-container fluid>

        <v-skeleton-loader v-if="isLoading" type="article, actions"></v-skeleton-loader>
        <v-row v-if="!isLoading" style="padding-bottom: 0px; margin-bottom: -36px;">
            <v-col cols="11">
                <p>{{ $t('wkt.admin.survey.stats.question-overview.answers-received') }}
                    {{survey.currentResponses}}/{{survey.expectedResponses}}</p>
            </v-col>
            <v-col cols="1" style="padding-bottom: 0px;">
                <v-btn icon color="primary" @click="print"><v-icon>print</v-icon></v-btn>
            </v-col>
        </v-row>
        <v-row style="width:100%" v-if="!isLoading" @wheel="onWheel">
            <v-data-table :loading="isLoading" :disableFiltering="true" :headers="headers" ref="dataTable" item-key="id"
                disable-sort :items="questionData" :disablePagination="true" hide-default-footer :fixedHeader="true"
                :height="tableHeight" style="width: 100%; max-height: calc(100vh - 280px);">
                <template v-slot:[`item.label`]="{ item }">
                    <span :class="item.type==='separator'?'primary--text font-weight-medium':''">{{item.label}}</span>
                </template>
                <template v-slot:[`item.type`]="{ item }">
                    <span>{{item.type!=='separator'?item.type:''}}</span>
                </template>

                <template v-slot:[`item.average`]="{ item }">
                    <span style="font-size:0.8em">{{item.average && isNumber(item.average)?(Math.round(item.average *
                        100) / 100).toFixed(2):''}}</span>
                </template>

                <template v-slot:[`item.count`]="{ item }">
                    <v-progress-linear v-if="item.type !== 'separator'"
                        :value="Math.min(100, survey.currentResponses > 0 ? 100 * item.count / survey.currentResponses : 0)"
                        :color="getProgressColor(survey.currentResponses > 0 ? 100 * item.count / survey.currentResponses : 0)"
                        height="12">
                        <template v-slot:default="{ value }">
                            <span style="font-size:0.8em">{{ item.type === 'radio' ? Math.round(item.count/survey.currentResponses*100) : Math.ceil(value) }}%</span>
                        </template>
                    </v-progress-linear>
                </template>

                <template v-slot:[`item.values`]="{ item }">
                    <div v-for="value in item.values" :key="value.value" style="display:flex">
                        <v-progress-linear v-if="item.type !== 'separator'"
                            :value="getDetailPercent(item, value)"
                            style="top:5px; max-width:170px;"
                            :color="getProgressColor(getDetailPercent(item, value))"
                            height="8">
                            <template v-slot:default="{ value }">
                                <div v-if="value && value != 0" style="font-size:0.6em">{{ Math.round(value) }}%</div>
                            </template>
                        </v-progress-linear>
                        <div style="min-width:40px; margin-left:5px; font-size:0.8em;">{{value.label}}</div>
                        <div v-if="isNumber(Number(value.value)) && item.type!='number' && item.type !== 'checkbox'"
                            style="min-width:20px; font-size:0.8em; color:#888">{{value.value}}</div>
                    </div>
                </template>

            </v-data-table>
        </v-row>
    </v-container>
</template>

<script> 

export default {
  name: 'QuestionOverview',
  components: { 
  },
  
  data() {
      return {
          components: [],
          questionData: [],
          tableHeight:200,
          isLoading: false,
          survey: {
              currentResponses:0
          },
          headers: [
                { text: this.$t("wkt.admin.survey.stats.question-overview.table.headers.question"), value: 'label', width: '60%' },
                { text: this.$t("wkt.admin.survey.stats.question-overview.table.headers.answered"), value: 'count', width: '5%' },
                { text: this.$t("wkt.admin.survey.stats.question-overview.table.headers.type"), value: 'type', width: '3%' },
                { text: this.$t("wkt.admin.survey.stats.question-overview.table.headers.detail"), value: 'values', width: '25%' },
                { text: this.$t("wkt.admin.survey.stats.question-overview.table.headers.average"), value: 'average', width: '3%' },
        ],
      }
  },
   methods: {
       /* eslint-disable no-unused-vars */
       processProperty(key,value) {
             //console.log(key + " : "+value);
        },
        onWheel(event) {
            event.stopPropagation();
        },
        processComponent(component) {

            if (component.showFieldStatistics===false) return;

            // If you want to add a new field, such as signature, you can do it here ↓
            if(['survey','tabs','radio','selectboxes','select','number','textarea','textfield','checkbox','columns'].includes(component.type))
            {
                if (component.type==='columns') {
                    for (let col of component.columns) {
                        for (let cc of col.components) {
                                this.processComponent(cc);
                            }
                    }
                }
                else
                if (component.type==='tabs') {
                    for (let tab of component.components) {
                        this.components.push(
                            {
                                key: tab.key,
                                label: tab.label,
                                type: 'separator',
                            }
                        );
                        for (let tc of tab.components) {
                             this.processComponent(tc);
                        }
                    }
                }
                else if (component.type==='survey') {
                    this.components.push(
                            {
                                key: component.key,
                                label: component.label,
                                type: 'separator',
                            }
                        );

                    for (let q of component.questions)
                    {
                        this.components.push(
                            {
                                key: component.key+'.'+q.value,
                                label: q.label,
                                type: 'survey',
                                average: null,
                                count: 0,
                                values: component.values.map(obj => ({...obj}))
                            }
                        );
                    }
                }
                else
                {
                    if (!component.values && component.data && component.data.values)
                        component.values=component.data.values;

                    if (!component.values)
                        component.values=[];

                    component.count = 0;
                    component.average = null;
                    this.components.push(component);
                }
            }
            else { 
                console.log('Ignring:'+component.type);
            }
                
        },
        traverse(o,fcomponent, fproperty) {
            for (var i in o) {
                fproperty.apply(this,[i,o[i]]);  
                if (o[i] !== null && typeof(o[i])=="object") { 
                    if (o[i].type)
                    {
                        fcomponent.apply(this,[o[i]]);
                    }
                    else
                    {
                        this.traverse(o[i],fcomponent, fproperty);
                    }
                }
            }
        },
        refresh(survey,submissionInfo) {
            this.isLoading=true;
            this.survey=survey;
            this.components = [];
            let qData = [];
            const me = this;

            setTimeout( function() {
                    me.traverse(JSON.parse(submissionInfo.form.definition),me.processComponent, me.processProperty);
                    
                    console.log(me.components);
                    for (let component of me.components) {
                        qData.push( {
                                id: component.key,
                                label: component.label,
                                type: component.type,
                                average: component.average,
                                count: component.count,
                                values: component.values,
                                showResponseDetail: component.showResponseDetail
                        });
                    }

                    me.processSubmissions(qData, submissionInfo.submissions);
                    me.processStats(qData);
                    me.questionData=qData;
                    me.isLoading=false; 
                    setTimeout( function() {
                        me.fixLayout(me);
                    },100);
                    console.log(qData);
            },100);
            
        },
        fixLayout(vm) {
            vm.tableHeight = window.getComputedStyle(vm.$refs.dataTable.$el, null).getPropertyValue("max-height");
        },
        isNumber(value) {
            return typeof value === 'number' && isFinite(value);
        },
        print() {
                var mywindow = window.open('', 'PRINT', 'height=400,width=1200');

                mywindow.document.write('<html><head><title>' + this.survey.title  + '</title>');
                mywindow.document.write('<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css" type="text/css" />');
                mywindow.document.write('<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Material+Icons" type="text/css" />');
                //mywindow.document.write('<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900" type="text/css" />');
                mywindow.document.write('<link rel="stylesheet" href="https://fonts.cdnfonts.com/css/google-sans" type="text/css" />');
                
                let root = document.querySelector('[data-app]');
                mywindow.document.write('<style>');
                mywindow.document.write(root.nextElementSibling.innerHTML);
                mywindow.document.write('</style>');
                

                mywindow.document.write('</head><body >');
                mywindow.document.write('<div class="v-application">'); 
                mywindow.document.write('<div class="v-data-table v-data-table--fixed-header theme--light" style="width:100%">');
                mywindow.document.write('<div class="v-data-table__wrapper" style="width:100%">');
                mywindow.document.write(this.$refs.dataTable.$el.firstChild.innerHTML);
                mywindow.document.write('</div></div></div></body></html>');

                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10*/

                setTimeout( function() {mywindow.print();mywindow.close();},1000);
                

            },
        getProgressColor(value) {
            if (value==0) return '#DDD';
            if (value<30) return 'orange';
            if (value<60) return 'yellow';
            if (value<80) return '#ddec59';
            if (value>80) return '#9acd32';
            return '#DDD';
        },
        processStats(questionData) {

            for (let q of questionData) {

                if (q.type === 'checkbox') continue;

                let average = 0;

                if (q.values) {
                    for (let v of q.values) {
                        if (v.count) {
                            average += v.count * v.value;
                        }
                    }

                    q.average = q.count>0?average/q.count:0;
                }
                
            }
            
        },
        processSubmissions(questionData, submissions) {

            for (let s of submissions) {
                if (s.submissionData)
                    this.processSubmission(questionData, JSON.parse(s.submissionData).data);
            }
            
        },
        processSubmission(questionData, submissionData, parentKey) {
            if (!submissionData) {
                console.warn('submissionData is null or undefined');
                return;
            }
            
            for (let [k,v] of Object.entries(submissionData)) {
                let question = questionData.find(q => q.id==k);
                if (typeof(v)=="object" && v !== null && (!question || question.type==='separator')) {
                    this.processSubmission(questionData, v, k);
                } else {
                    let key = parentKey ? parentKey + '.' + k : k;
                    this.processResponse(questionData, key, v);
                }
            }
        },
       processResponse(questionData, key, value) {
           const q = questionData.find(q => q.id === key);
           if (!q || !q.values || q.type === 'separator') return;

           let valuesToProcess = new Set();

           if (Array.isArray(value)) {
               value.forEach(val => valuesToProcess.add(val));
           } else if (typeof value === "object") {
               for (let [k, v] of Object.entries(value)) {
                   if (v === true || (typeof v === "string" && v.trim() !== "")) {
                       valuesToProcess.add(k);
                   }
               }
           } else {
               if (value !== '' && value !== null && value !== undefined) valuesToProcess.add(value);
           }

           if (q.type === 'textarea' || q.type === 'textfield') {
               if (valuesToProcess.size > 0) {
                   q.count += 1; // número de usuarios que respondieron este campo
                   valuesToProcess.forEach(val => this.processValue(q.values, val));
               }
           } else if (q.type === 'radio') {
               if (valuesToProcess.size > 0) {
                   q.count += 1;
               }
           } else if (q.type === 'select') {
               // Para SELECT (single o multiple), solo contar si hay alguna respuesta válida
               if (valuesToProcess.size > 0) {
                   q.count += 1;
               }
           } else if (q.type === 'signature') {
               // Para SIGNATURE, contar solo si existe firma (string/base64 no vacío)
               if (valuesToProcess.size > 0) {
                   q.count += 1;
               }
           } else if (q.type === 'selectboxes' || q.type === 'checkbox') {
               // Para SELECTBOXES/CHECKBOX, solo contar si el usuario marcó al menos una opción
               if (valuesToProcess.size > 0) {
                   q.count += 1;
               }
           } else {
               q.count += 1;
           }

           // Procesar valores normalmente para otros tipos
           if (q.type !== 'textarea' && q.type !== 'textfield') {
               if (q.type === 'select' && valuesToProcess.size > 1) {
                   let countFactor = 1 / valuesToProcess.size;
                   valuesToProcess.forEach(val => this.processValue(q.values, val, countFactor));
               } else {
                   valuesToProcess.forEach(val => this.processValue(q.values, val));
               }
           }
       },
        getDetailTotal(item) {
            if (!item || !item.values) return 0;
            return item.values.reduce((sum, v) => sum + (Number(v.count) || 0), 0);
        },
        getDetailPercent(item, value) {
            if (!item || !item.values) return 0;

            // Para SELECTBOXES/CHECKBOX: % por opción = usuarios que la marcaron / usuarios que respondieron la pregunta
            if (item.type === 'selectboxes' || item.type === 'checkbox') {
                const respondents = Number(item.count) || 0;
                const count = Number(value && value.count) || 0;
                return respondents > 0 ? Math.min(100, (100 * count) / respondents) : 0;
            }

            // Resto de tipos: mantener lógica actual basada en distribución interna
            const total = item.values.reduce((sum, v) => sum + (Number(v.count) || 0), 0);
            const count = Number(value && value.count) || 0;
            return total > 0 ? (100 * count) / total : 0;
        },
       processValue(values, value, countFactor = 1) {
           let v = values.find(v => v.value == value);

           if (!v) {
               v = {
                   label: value,
                   value: value,
                   count: 0
               };
               values.push(v);
           }

           if (!v.count) v.count = 0;

           v.count += countFactor; // Suma ajustando el peso para respuestas múltiples

           console.log(`[processValue] Opción: ${v.label}, Count: ${v.count.toFixed(2)}`);
       }
   }
};
</script>
